import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kehubaifangjilu",
  "use": "icon-kehubaifangjilu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-kehubaifangjilu\"><path d=\"M8 0A8 8 0 11.622 4.901l.886.887a6.857 6.857 0 102.63-3.455l.566.98-2.837-.343L2.99.343l.576.997A7.963 7.963 0 018 0zm-.5 3.429a.5.5 0 01.5.5v5.457l1.76 1.015a.5.5 0 01.182.683l-.071.124a.5.5 0 01-.683.183l-1.936-1.116a.5.5 0 01-.344-.27.502.502 0 01-.052-.407l.001-5.67a.5.5 0 01.5-.5H7.5z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/kehubaifangjilu.svg
// module id = 482
// module chunks = 4